import React from "react";
import SuiBox from "components/SuiBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Grid from "@mui/material/Grid";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import { SETTINGS_TABS } from "./settings.constants";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import usePermissions from "utils/usePermissions";

function Settings() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { can } = usePermissions();

  const isSettingsIndex = pathname === "/settings" || pathname === "/settings/";

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox py={3}>
          {isSettingsIndex ? (
            <SuiBox mb={3}>
              <Grid container spacing={3}>
                {SETTINGS_TABS.filter((tab) => can(tab.permission)).map((tab, index) => (
                  <Grid key={index} item xs={12} sm={6} xl={4}>
                    <div
                      onClick={() => navigate(tab.path)}
                      className="cursor-pointer user-select-none dashboard-cards"
                    >
                      <MiniStatisticsCard
                        title={{ text: tab.text }}
                        count=""
                        icon={{
                          color: tab.iconColor,
                          component: tab.iconComponent,
                        }}
                      />
                    </div>
                  </Grid>
                ))}
              </Grid>
            </SuiBox>
          ) : (
            <Outlet />
          )}
        </SuiBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}

export default Settings;
